import store from '@/store'
import { commonUtil } from '@/util'
import { stockMoveStatusHistory } from '@/config'

export default {
  getStockMoveReasonById(id) {
    const list = store.getters['StockMove/getStockMoveReasonListFromState']
    const ret = list.find((v) => v.stockMoveReasonId == id)
    return ret
  },
  async getStorageIdNameList(isHideUnusedStorageMoveReason = false) {
    const list = isHideUnusedStorageMoveReason
      ? await store.dispatch('StockMove/getStockMoveReasonListFromApi', {
          isHideUnusedStockMoveReason: 1
        })
      : await store.dispatch('StockMove/getStockMoveReasonListFromApi')
    // API実行失敗
    if (!list) {
      return {}
    }
    const stockMoveIdNameList = list.data.map((ele) => {
      return { label: ele.name, value: ele.stockMoveReasonId }
    })
    return {
      code: list.code,
      message: list.message,
      data: stockMoveIdNameList
    }
  },
  getStockMoveStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      stockMoveStatusHistory.STATUS,
      stockMoveStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getStockMoveStatusListForSelectBox() {
    return commonUtil.getStatusHistoryIdNameList(
      stockMoveStatusHistory.STATUS_SELECTBOX,
      stockMoveStatusHistory.STATUS_HISTORY_LABEL_SELECTBOX
    )
  },

  getStockMoveStatusName(status) {
    const ret = this.getStockMoveStatusList().find(
      (ele) => ele.value === status
    )
    return ret ? ret.label : '-'
  },

  getStockMoveButtonName(status) {
    switch (status) {
      case stockMoveStatusHistory.STATUS.STOCK:
        return 'ship.ship_ship'
      case stockMoveStatusHistory.STATUS.SHIP:
        return 'ship.ship_arrival'
      case stockMoveStatusHistory.STATUS.ARRIVAL:
        return 'ship.ship_arrival'
      default:
        return ' - '
    }
  },

  isStockMoveButtonDisable(status) {
    switch (status) {
      case stockMoveStatusHistory.STATUS.STOCK:
        return false
      case stockMoveStatusHistory.STATUS.SHIP:
        return false
      case stockMoveStatusHistory.STATUS.ARRIVAL:
        return true
      default:
        return true
    }
  }
}
